<template>
  <div>
    <Head title="Create User" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/users">Users </Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
          <phone-input v-model.phoneFormat="form.phone" :type="tel" :error="form.errors.phone" class="relative pr-6 pb-8 w-full lg:w-1/2" label="Phone" />
          <text-input v-model="form.nmls" :error="form.errors.nmls" class="pb-8 pr-6 w-full lg:w-1/2" label="NMLS ID" />
          <text-input v-model="form.appointment_link" :error="form.errors.appointment_link" class="pr-6 pb-8 w-full" label="Appointment Link" />
          <text-input v-model="form.application_link" :error="form.errors.application_link" class="pr-6 pb-8 w-full" label="Application Link" />
          <text-input v-model="form.application_api" :error="form.errors.application_api" class="pb-8 pr-6 w-full lg:w-1/2" label="Application API" />
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
          <select-input v-model="form.role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-1/2" label="Role">
            <option value="LoanOfficer">LoanOfficer</option>
            <option value="Processor">Processor</option>
            <option value="Staff">Staff</option>
          </select-input>
          <select-input v-model="form.owner" :error="form.errors.owner" class="pb-8 pr-6 w-full lg:w-1/2" label="Owner">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select-input>
          <text-input v-model="form.phone_pass" :error="form.errors.phone_pass" class="pb-8 pr-6 w-full lg:w-1/2" label="Ringcentral Pass" />
          <text-input v-model="form.phone_extension" :error="form.errors.phone_extension" class="pb-8 pr-6 w-full lg:w-1/2" label="Ringcentral Extension" />
          <div class="w-full pr-6 pb-8">
            <SignatureEditor :emailSignature="form.signature" @change-signature="updateSignature($event)" />
          </div></div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import SignatureEditor from '@/Shared/SignatureEditor'
import PhoneInput from '@/Shared/PhoneInput'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    PhoneInput,
    SignatureEditor,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: router.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        owner: false,
        photo: null,
        signature: '',
        phone: '',
        role: '',
        nmls: '',
        application_api: '',
        application_link: '',
        appointment_link: '',
        phone_pass: '',
        phone_extension: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/users')
    },
    updateSignature: function(signature){
      this.form.signature=signature
    }
  },
}
</script>
